import React from 'react'
import styled from 'styled-components'
import theme from './theme.js'
import {Icon} from './icon-inline.js'

const UnstyledIconSearch = ({
  className
}) => {
  const props = {
    className 
  }

  return (
    <Icon {...props}/>
  )
}

const IconSearch = styled(UnstyledIconSearch)`
  width: 1em;
  height: 1em;
  border: none; 

  &:after {
    width: .6em;
    height: .6em;
    border: 2px solid ${theme.color.grey.darkest};
    border-radius: 100px;
    content: '';
    position: absolute;
    top: .1em;
    left: 50%;
    transform: translateX(-50%);
  }

  &:before {
    content: '';
    height: .41em;
    width: 2px;
    background: ${theme.color.grey.darkest};
    position: absolute;
    top: .7em;
    right: -1px;
    transform: rotate(-45deg);
  }
`
export default IconSearch